import React, { useEffect, useState } from 'react'
import { Row } from 'reactstrap';
import ObPfHoldingsBase from './ObPfHoldingsBase';
import moment from 'moment';
import { getInterstAmount, getPortfolio } from '../services/waitlist-service';
import { toast } from 'react-toastify';

const MaturedCard = (props) => {
  const [producttypes, setProductTypes] = useState([]);
  const {isMobile, requests} = props;
  const [showCouponsTable, setShowCouponsTable] = useState(false);
  
  useEffect(() => {
    let tmpproductypes = [];

    for (const item of requests) {
      const value = item.productType;
      if (!tmpproductypes.includes(value)) {
        tmpproductypes.push(value);
      }
    }
    setProductTypes([...tmpproductypes]);
  },[props]) 

  return !isMobile
    ? (producttypes &&
        producttypes.length) ?
        producttypes?.map((entry) => (
      requests.some(pt => pt.productType === entry) ?
          <Row className="matured-wrapper" key={entry}>
            <p className="font-weight-semi-bold header mb-3">
              {entry === "bonds"
                ? "Bonds"
                : entry === "mld"
                ? "Market Linked Debentures"
                : ""}
            </p>
            {requests?.map((item, index) => {
              if (item.productType === entry) {
                return (
                  <div key={item.orderId} className="matured-outer">
                    <ObPfHoldingsBase
                      title={props?.bondDetails?.filter((e) => e.product === item.product)[0]
                        ?.issuer}
                      img={
                        props?.bondDetails?.find(
                          (e) => e.product === item.product
                        )?.logoUrl
                      }
                      firstCard={true}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Payout Amount"
                      value={item?.pfStats.couponPayout ? (item?.pfStats.couponPayout).oroNumber(2, true) : "--"}
                      isMobile={isMobile}
                      showMore={true}
                      productm={item?.pfStats.pastCoupons[0].product}
                    />
                    <ObPfHoldingsBase
                      title="Amount Invested"
                      value={item?.pfStats?.userInvestedAmt ? (item?.pfStats?.userInvestedAmt).oroNumber(2, true) : "--"}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="XIRR"
                      value={item?.userXirr + "%"}
                      index={index}
                      isMobile={isMobile}
                      infoText={"Lorem Ipsum text"}
                    />
                    <ObPfHoldingsBase
                      title="Maturity Date"
                      value={item?.pfStats?.maturityDate ? moment(new Date(item?.pfStats?.maturityDate)).format("Do MMM YYYY") : "--"}
                      index={index}
                      isMobile={isMobile}
                      infoText={"Lorem Ipsum text"}
                    />
                  </div>
                );
              }
              return null; // Return null for items that don't match the condition
            })}
          </Row> : null
        ))
        : <Row className='matured-wrapper'>
            <p className="font-weight-semi-bold header mb-3 text-center">
              No Matured Deals
            </p>
        </Row>
    : 
    (producttypes &&
    producttypes.length) ?
    producttypes?.map((entry) => (
      requests.some(pt => pt.productType === entry) ?
        <Row className="matured-wrapper" key={entry}>
          <p className="font-weight-semi-bold header mb-3">
            {entry === "bonds"
                ? "Bonds"
                : entry === "mld"
                ? "Market Linked Debentures"
                : ""
            }
          </p>
          {requests?.map((item, index) => {
              if (item.productType === entry) {
                return (
          <div key={item.orderId} className="matured-outer">
            <ObPfHoldingsBase
              title={props?.bondDetails?.filter((e) => e.product === item.product)[0]
                ?.issuer}
              img={
                props?.bondDetails?.find(
                  (e) => e.product === item.product
                )?.logoUrl
              }
              firstCard={true}
              isMobile={isMobile}
            />

            <div className="hr"></div>
            <div className="wrapper">
              <ObPfHoldingsBase 
                title="Payout Amount" 
                value={item?.pfStats.couponPayout ? (item?.pfStats.couponPayout).oroNumber(2, true) : "--"}
                isMobile={isMobile}
                showMore={true}
                productm={item?.pfStats.pastCoupons[0].product}
             />
              <ObPfHoldingsBase
                title="Amount Invested"
                value={item?.pfStats?.userInvestedAmt ? (item?.pfStats?.userInvestedAmt).oroNumber(2, true) : "--"}
                isMobile={isMobile}
              />
              <ObPfHoldingsBase
                title="XIRR"
                value={item?.userXirr + "%"}
                isMobile={isMobile}
                infoText={"Lorem Ipsum text"}
                index={index}
              />
              <ObPfHoldingsBase
                title="Maturity Date"
                value={item?.pfStats?.maturityDate ? moment(new Date(item?.pfStats?.maturityDate)).format("Do MMM YYYY") : "--"}
                isMobile={isMobile}
                infoText={"Lorem Ipsum text"}
                index={index}
              />
            </div>
            {/* <span className="view" onClick={() => redirectToProduct(item, props.holdings[item].productType)}>
                  View Details
                </span> */}
          </div>
                );
              }
              return null; // Return null for items that don't match the condition
            })}
        </Row> 
        : null
      ))
    :
    <Row className='matured-wrapper'>
        <p className="font-weight-semi-bold header mb-3 text-center">
          No Matured deals
        </p>
    </Row>
    
}

export default MaturedCard